/* eslint-disable react/forbid-prop-types */
import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@design-system-coopeuch/web';
import { WrapperFooter } from './styles';

const Botonera = ({ tituloboton, verificarFunction, volverHome, estadoBotonUno, estadoBotonDos, activeMenu }) => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { nameDos, nameUno } = tituloboton[0];
  return (
    <WrapperFooter>
      <div className="verificar">
        {activeMenu!== 5 ? (
          <Button variant='outline' onClick={verificarFunction} disabled={!estadoBotonUno}>{nameUno}</Button>
        ) : ("")}
      </div>
      <div className={activeMenu === 5  ?'volver btn-comprobante':'volver'}>
        <Button variant='text' onClick={volverHome} disabled={estadoBotonDos}>{nameDos}</Button>
      </div>
    </WrapperFooter>
  )
}
Botonera.propTypes = {
  tituloboton: PropTypes.arrayOf(PropTypes.object),
  estadoBotonUno: PropTypes.bool,
  estadoBotonDos: PropTypes.bool,
  verificarFunction: PropTypes.func,
  volverHome: PropTypes.func,
  activeMenu: PropTypes.number

};
Botonera.defaultProps = ({ tituloboton: {}, verificarFunction: () => { }, volverHome: () => { }, estadoBotonUno: '', estadoBotonDos: '', activeMenu: 0 });
export default Botonera;